(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDialogController', CloudPBXPrefixDialogController);

    CloudPBXPrefixDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CloudPBXPrefix', 'CloudPBX'];

    function CloudPBXPrefixDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CloudPBXPrefix, CloudPBX) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cloudPBXPrefix.id !== null) {
                CloudPBXPrefix.update(vm.cloudPBXPrefix, onSaveSuccess, onSaveError);
            } else {
                CloudPBXPrefix.save(vm.cloudPBXPrefix, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:cloudPBXPrefixUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
